// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputStyle {
  width: 3.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  border-radius: 0.3125rem;
  font-size: 1.625rem;
  font-weight: bold;
  color: reddishOrange;
  background-color: palePink;
  outline: none;
}

.inputStyle:focus {
  background-color: reddishOrange;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/user/step-two/steptwo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":[".inputStyle {\n  width: 3.5rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  text-align: center;\n  border-radius: 0.3125rem;\n  font-size: 1.625rem;\n  font-weight: bold;\n  color: reddishOrange;\n  background-color: palePink;\n  outline: none;\n}\n\n.inputStyle:focus {\n  background-color: reddishOrange;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
